// @generated source--
// scripts/generate-bits/file-generators/component-routes.generator.ts

export const componentRoutes = [
  {
    path: 'all',
    loadChildren: () => import('./sink/sink.routing').then(m => m.routes),
  },
  {
    path: 'anchor-scroll',
    loadChildren: () =>
      import('./anchor-scroll/anchor-scroll-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'animated-svg',
    loadChildren: () =>
      import('./animated-svg/animated-svg-stories.routes').then(m => m.routes),
  },
  {
    path: 'annotation-indicator',
    loadChildren: () =>
      import('./annotation-indicator/annotation-indicator-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'badge',
    loadChildren: () =>
      import('./badge/badge-stories.routes').then(m => m.routes),
  },
  {
    path: 'banner-alert',
    loadChildren: () =>
      import('./banner-alert/banner-alert-stories.routes').then(m => m.routes),
  },
  {
    path: 'banner-announcement',
    loadChildren: () =>
      import('./banner-announcement/banner-announcement-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'banner-upsell',
    loadChildren: () =>
      import('./banner-upsell/banner-upsell-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'breadcrumbs',
    loadChildren: () =>
      import('./breadcrumbs/breadcrumbs-stories.routes').then(m => m.routes),
  },
  {
    path: 'button',
    loadChildren: () =>
      import('./button/button-stories.routes').then(m => m.routes),
  },
  {
    path: 'callout',
    loadChildren: () =>
      import('./callout/callout-stories.routes').then(m => m.routes),
  },
  {
    path: 'camera-input',
    loadChildren: () =>
      import('./camera-input/camera-input-stories.routes').then(m => m.routes),
  },
  {
    path: 'card-list',
    loadChildren: () =>
      import('./card-list/card-list-stories.routes').then(m => m.routes),
  },
  {
    path: 'card',
    loadChildren: () =>
      import('./card/card-stories.routes').then(m => m.routes),
  },
  {
    path: 'carousel',
    loadChildren: () =>
      import('./carousel/carousel-stories.routes').then(m => m.routes),
  },
  {
    path: 'chart',
    loadChildren: () =>
      import('./chart/chart-stories.routes').then(m => m.routes),
  },
  {
    path: 'checkbox-card',
    loadChildren: () =>
      import('./checkbox-card/checkbox-card-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'checkbox',
    loadChildren: () =>
      import('./checkbox/checkbox-stories.routes').then(m => m.routes),
  },
  {
    path: 'container',
    loadChildren: () =>
      import('./container/container-stories.routes').then(m => m.routes),
  },
  {
    path: 'countdown-timer',
    loadChildren: () =>
      import('./countdown-timer/countdown-timer-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'currency-input',
    loadChildren: () =>
      import('./currency-input/currency-input-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'display-card',
    loadChildren: () =>
      import('./display-card/display-card-stories.routes').then(m => m.routes),
  },
  {
    path: 'drawer',
    loadChildren: () =>
      import('./drawer/drawer-stories.routes').then(m => m.routes),
  },
  {
    path: 'dropdown-filter',
    loadChildren: () =>
      import('./dropdown-filter/dropdown-filter-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'emoji-picker',
    loadChildren: () =>
      import('./emoji-picker/emoji-picker-stories.routes').then(m => m.routes),
  },
  {
    path: 'file-display',
    loadChildren: () =>
      import('./file-display/file-display-stories.routes').then(m => m.routes),
  },
  {
    path: 'file-select',
    loadChildren: () =>
      import('./file-select/file-select-stories.routes').then(m => m.routes),
  },
  {
    path: 'file-viewer',
    loadChildren: () =>
      import('./file-viewer/file-viewer-stories.routes').then(m => m.routes),
  },
  {
    path: 'flag',
    loadChildren: () =>
      import('./flag/flag-stories.routes').then(m => m.routes),
  },
  {
    path: 'floating-action',
    loadChildren: () =>
      import('./floating-action/floating-action-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'focus',
    loadChildren: () =>
      import('./focus/focus-stories.routes').then(m => m.routes),
  },
  {
    path: 'fonts',
    loadChildren: () =>
      import('./fonts/fonts-stories.routes').then(m => m.routes),
  },
  {
    path: 'form-save',
    loadChildren: () =>
      import('./form-save/form-save-stories.routes').then(m => m.routes),
  },
  {
    path: 'gallery-grid',
    loadChildren: () =>
      import('./gallery-grid/gallery-grid-stories.routes').then(m => m.routes),
  },
  {
    path: 'gallery-mosaic',
    loadChildren: () =>
      import('./gallery-mosaic/gallery-mosaic-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'generic-error',
    loadChildren: () =>
      import('./generic-error/generic-error-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'grid',
    loadChildren: () =>
      import('./grid/grid-stories.routes').then(m => m.routes),
  },
  {
    path: 'highlight-text',
    loadChildren: () =>
      import('./highlight-text/highlight-text-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'highlight',
    loadChildren: () =>
      import('./highlight/highlight-stories.routes').then(m => m.routes),
  },
  {
    path: 'hr',
    loadChildren: () => import('./hr/hr-stories.routes').then(m => m.routes),
  },
  {
    path: 'icon',
    loadChildren: () =>
      import('./icon/icon-stories.routes').then(m => m.routes),
  },
  {
    path: 'image-cropper',
    loadChildren: () =>
      import('./image-cropper/image-cropper-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'infinite-scroll',
    loadChildren: () =>
      import('./infinite-scroll/infinite-scroll-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'input',
    loadChildren: () =>
      import('./input/input-stories.routes').then(m => m.routes),
  },
  {
    path: 'label',
    loadChildren: () =>
      import('./label/label-stories.routes').then(m => m.routes),
  },
  {
    path: 'link',
    loadChildren: () =>
      import('./link/link-stories.routes').then(m => m.routes),
  },
  {
    path: 'list',
    loadChildren: () =>
      import('./list/list-stories.routes').then(m => m.routes),
  },
  {
    path: 'loading-template',
    loadChildren: () =>
      import('./loading-template/loading-template-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'location-input',
    loadChildren: () =>
      import('./location-input/location-input-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'logo',
    loadChildren: () =>
      import('./logo/logo-stories.routes').then(m => m.routes),
  },
  {
    path: 'map',
    loadChildren: () => import('./map/map-stories.routes').then(m => m.routes),
  },
  {
    path: 'margin',
    loadChildren: () =>
      import('./margin/margin-stories.routes').then(m => m.routes),
  },
  {
    path: 'media-viewer',
    loadChildren: () =>
      import('./media-viewer/media-viewer-stories.routes').then(m => m.routes),
  },
  {
    path: 'modal',
    loadChildren: () =>
      import('./modal/modal-stories.routes').then(m => m.routes),
  },
  {
    path: 'more-options',
    loadChildren: () =>
      import('./more-options/more-options-stories.routes').then(m => m.routes),
  },
  {
    path: 'multi-select',
    loadChildren: () =>
      import('./multi-select/multi-select-stories.routes').then(m => m.routes),
  },
  {
    path: 'multiple-location-input',
    loadChildren: () =>
      import(
        './multiple-location-input/multiple-location-input-stories.routes'
      ).then(m => m.routes),
  },
  {
    path: 'new-feature-tag',
    loadChildren: () =>
      import('./new-feature-tag/new-feature-tag-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'online-indicator',
    loadChildren: () =>
      import('./online-indicator/online-indicator-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'otp-input',
    loadChildren: () =>
      import('./otp-input/otp-input-stories.routes').then(m => m.routes),
  },
  {
    path: 'page-layout',
    loadChildren: () =>
      import('./page-layout/page-layout-stories.routes').then(m => m.routes),
  },
  {
    path: 'pagination',
    loadChildren: () =>
      import('./pagination/pagination-stories.routes').then(m => m.routes),
  },
  {
    path: 'phone-input',
    loadChildren: () =>
      import('./phone-input/phone-input-stories.routes').then(m => m.routes),
  },
  {
    path: 'picture',
    loadChildren: () =>
      import('./picture/picture-stories.routes').then(m => m.routes),
  },
  {
    path: 'progress-bar',
    loadChildren: () =>
      import('./progress-bar/progress-bar-stories.routes').then(m => m.routes),
  },
  {
    path: 'progress-steps',
    loadChildren: () =>
      import('./progress-steps/progress-steps-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'pull-refresh',
    loadChildren: () =>
      import('./pull-refresh/pull-refresh-stories.routes').then(m => m.routes),
  },
  {
    path: 'radio',
    loadChildren: () =>
      import('./radio/radio-stories.routes').then(m => m.routes),
  },
  {
    path: 'rating',
    loadChildren: () =>
      import('./rating/rating-stories.routes').then(m => m.routes),
  },
  {
    path: 'relative-time',
    loadChildren: () =>
      import('./relative-time/relative-time-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'ribbon',
    loadChildren: () =>
      import('./ribbon/ribbon-stories.routes').then(m => m.routes),
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./search/search-stories.routes').then(m => m.routes),
  },
  {
    path: 'select',
    loadChildren: () =>
      import('./select/select-stories.routes').then(m => m.routes),
  },
  {
    path: 'share-buttons',
    loadChildren: () =>
      import('./share-buttons/share-buttons-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'share-link',
    loadChildren: () =>
      import('./share-link/share-link-stories.routes').then(m => m.routes),
  },
  {
    path: 'slider',
    loadChildren: () =>
      import('./slider/slider-stories.routes').then(m => m.routes),
  },
  {
    path: 'smart-textarea',
    loadChildren: () =>
      import('./smart-textarea/smart-textarea-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'social-buttons',
    loadChildren: () =>
      import('./social-buttons/social-buttons-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'spinner',
    loadChildren: () =>
      import('./spinner/spinner-stories.routes').then(m => m.routes),
  },
  {
    path: 'split-button',
    loadChildren: () =>
      import('./split-button/split-button-stories.routes').then(m => m.routes),
  },
  {
    path: 'sticky-footer',
    loadChildren: () =>
      import('./sticky-footer/sticky-footer-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'table',
    loadChildren: () =>
      import('./table/table-stories.routes').then(m => m.routes),
  },
  {
    path: 'tabs',
    loadChildren: () =>
      import('./tabs/tabs-stories.routes').then(m => m.routes),
  },
  {
    path: 'tag-status',
    loadChildren: () =>
      import('./tag-status/tag-status-stories.routes').then(m => m.routes),
  },
  {
    path: 'tag',
    loadChildren: () => import('./tag/tag-stories.routes').then(m => m.routes),
  },
  {
    path: 'tailwind-text',
    loadChildren: () =>
      import('./tailwind-text/tailwind-text-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'textarea',
    loadChildren: () =>
      import('./textarea/textarea-stories.routes').then(m => m.routes),
  },
  {
    path: 'thumbnail-viewer',
    loadChildren: () =>
      import('./thumbnail-viewer/thumbnail-viewer-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'timepicker',
    loadChildren: () =>
      import('./timepicker/timepicker-stories.routes').then(m => m.routes),
  },
  {
    path: 'toast-alert',
    loadChildren: () =>
      import('./toast-alert/toast-alert-stories.routes').then(m => m.routes),
  },
  {
    path: 'toggle-buttons',
    loadChildren: () =>
      import('./toggle-buttons/toggle-buttons-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'toggle',
    loadChildren: () =>
      import('./toggle/toggle-stories.routes').then(m => m.routes),
  },
  {
    path: 'tooltip',
    loadChildren: () =>
      import('./tooltip/tooltip-stories.routes').then(m => m.routes),
  },
  {
    path: 'unread-indicator',
    loadChildren: () =>
      import('./unread-indicator/unread-indicator-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'user-activity-status',
    loadChildren: () =>
      import('./user-activity-status/user-activity-status-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'user-avatar',
    loadChildren: () =>
      import('./user-avatar/user-avatar-stories.routes').then(m => m.routes),
  },
  {
    path: 'validation-error',
    loadChildren: () =>
      import('./validation-error/validation-error-stories.routes').then(
        m => m.routes,
      ),
  },
  {
    path: 'video-modal',
    loadChildren: () =>
      import('./video-modal/video-modal-stories.routes').then(m => m.routes),
  },
  {
    path: 'video',
    loadChildren: () =>
      import('./video/video-stories.routes').then(m => m.routes),
  },
  {
    path: 'view-header',
    loadChildren: () =>
      import('./view-header/view-header-stories.routes').then(m => m.routes),
  },
  {
    path: 'widget',
    loadChildren: () =>
      import('./widget/widget-stories.routes').then(m => m.routes),
  },
];
